const isEmail = require('isemail');

export default angular
  .module('doxy.common.directives.dValidateEmail', [])
  .directive('dValidateEmail', function () {
    return {
      restrict: 'A',
      scope: false,
      require: 'ngModel',
      link: function (scope, el, attrs, ngModelCtrl) {
        ngModelCtrl.$validators.email = function (modelVal, viewVal) {
          const val = modelVal || viewVal;

          if (val) {
            return isEmail.validate(val);
          } else {
            return true;
          }
        };
      },
    };
  }).name;
